import { Controller } from "stimulus"
import UnsavedChanges from "../unsaved_changes"
import { submitJsonForm, errorMessages } from "../form_submission"

export default class extends Controller {
    static targets = [ 
                        "form", "updated", "saveState", "saveStatus", "sessionLogin", "sessionCheck", "self_assessment", "self_assessment_fields",
                        "first_level", "second_level", "third_level", "fourth_level"
                        ]

    connect() {
        this.sessionFeedback = event => this.updateSessionStatus(event.detail)
        document.addEventListener("session:feedback", this.sessionFeedback)
        this.calculateResults()
        if (this.hasFormTarget) this.unsavedChanges = new UnsavedChanges(this.formTarget)
    }

    disconnect() {
        if (this.unsavedChanges) this.unsavedChanges.disconnect()
        document.removeEventListener("session:feedback", this.sessionFeedback)
    }

    showSelectedDescription(answer) {
        const questionGroup = answer.closest(".question-group")

        if (!questionGroup) {
            return
        }

        questionGroup.querySelectorAll(".description small").forEach((description) => {
            description.style.display = "none"
        })

        const selectedDescription = questionGroup.querySelector(`.description_${answer.value}`)
        if (selectedDescription) {
            selectedDescription.style.display = "block"
        }
    }

    calculateResults() {
        if (this.hasSelf_assessmentTarget) {
            let firstLevel = 0
            let secondLevel = 0
            let thirdLevel = 0
            let fourthLevel = 0
            let totalItems = this.self_assessmentTarget.dataset.count

            const selectedValues = this.self_assessment_fieldsTarget.querySelectorAll("input[type=radio]:checked")
            selectedValues.forEach((answer) => {
                this.showSelectedDescription(answer)

                if(answer.value == 1) {
                    firstLevel += 1
                } else if (answer.value == 2) {
                    secondLevel += 1
                } else if (answer.value == 3) {
                    thirdLevel += 1
                } else if (answer.value == 4) {
                    fourthLevel += 1
                }
            })

            let firstLevelPercentage = (firstLevel / totalItems * 100)
            let secondLevelPercentage = (secondLevel / totalItems * 100)
            let thirdLevelPercentage = (thirdLevel / totalItems * 100)
            let fourthLevelPercentage = (fourthLevel / totalItems * 100)

            this.first_levelTarget.textContent = firstLevelPercentage.toFixed(0) + "%"
            this.second_levelTarget.textContent = (secondLevelPercentage + thirdLevelPercentage + fourthLevelPercentage).toFixed(0) + "%"
            this.third_levelTarget.textContent = (thirdLevelPercentage + fourthLevelPercentage).toFixed(0) + "%"
            this.fourth_levelTarget.textContent = (fourthLevelPercentage).toFixed(0) + "%"
        }
    }

    save(event) {
        submitJsonForm(event, {
            saving: () => {
                this.setStatus("Saglabā...", "saving")
            },
            success: (data) => {
                this.synchronizeRows(data.rows)
                this.updatedTarget.textContent = data.updated_at
                this.setStatus("Atskaite saglabāta!", "saved")
            },
            error: (data) => this.error(data)
        })
    }

    synchronizeRows(associations = {}) {
        Object.entries(associations).forEach(([association, rows]) => {
            const ids = new Map(rows.map(row => [row.revision_key, row.id]))
            this.formTarget.querySelectorAll(`input[name^="report[${association}_attributes]"][name$="[revision_key]"]`).forEach(key => {
                if (!ids.has(key.value)) return
                const name = key.name.replace(/\[revision_key\]$/, "[id]")
                let input = Array.from(this.formTarget.elements).find(element => element.name === name)
                if (!input) {
                    input = document.createElement("input")
                    input.type = "hidden"
                    input.name = name
                    key.insertAdjacentElement("afterend", input)
                }
                input.value = ids.get(key.value)
                const activity = key.closest(".report-editor__activity-row")
                if (activity) activity.dataset.itemId = input.value
            })
        })
    }

    error(data) {
        if (data && data.session && this.sessionState === "expired") {
            this.updateSessionStatus({ state: "expired", message: this.sessionMessage })
            return
        }
        const explanation = errorMessages(data)
        this.setStatus(explanation ? `Kļūda saglabājot! ${explanation}` : "Kļūda saglabājot! Pārbaudi savienojumu un mēģini vēlreiz.", "error")
    }

    uploadError() {
        this.setStatus("Faila augšupielāde neizdevās. Izmaiņas nav saglabātas.", "error")
    }

    setStatus(message, state, sessionFeedback = false) {
        if (!sessionFeedback) this.lastFormStatus = { message, state }
        if (this.hasSaveStateTarget) {
            this.saveStateTarget.dataset.state = state
            this.saveStateTarget.setAttribute("role", state === "error" ? "alert" : "status")
            this.saveStateTarget.setAttribute("aria-live", state === "error" ? "assertive" : "polite")
        }
        if (this.hasSaveStatusTarget) this.saveStatusTarget.textContent = message
        if (this.hasSessionLoginTarget) this.sessionLoginTarget.hidden = true
        if (this.hasSessionCheckTarget) this.sessionCheckTarget.hidden = true
    }

    updateSessionStatus({ state, message }) {
        if (!this.hasSaveStateTarget) return
        const previous = this.sessionState
        this.sessionState = state
        this.sessionMessage = message
        if (state === "healthy") {
            if (previous === "connection") {
                const result = this.lastFormStatus || { message: "Izmaiņas saglabā ar pogu “Saglabāt”.", state: "idle" }
                this.setStatus(result.message, result.state, true)
            }
            return
        }
        if (state === "recovered") this.lastFormStatus = { message, state: "warning" }
        this.setStatus(message, state === "expired" ? "error" : "warning", true)
        if (this.hasSessionLoginTarget) this.sessionLoginTarget.hidden = state !== "expired"
        if (this.hasSessionCheckTarget) this.sessionCheckTarget.hidden = state !== "expired"
    }

    checkSession() {
        document.dispatchEvent(new CustomEvent("session:check"))
    }
}
